// extracted by mini-css-extract-plugin
export default {"cellContainer":"BenefactorPaymentsTable_cellContainer__F-cGJ"};